import { render, staticRenderFns } from "./ServerNotifications.vue?vue&type=template&id=a4a424da"
import script from "./ServerNotifications.vue?vue&type=script&lang=js"
export * from "./ServerNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports